// const baseUrl = "https://reaksi-api.vercel.app/api";
const baseUrl = "https://express.reaksikuy.com";
// const baseUrl = "http://localhost:3000/api";

export default baseUrl;
